const LocalStorageHelper = {
	getUsername() {
		try {
			const obj = JSON.parse(localStorage.getItem('ldr_student'));
			return obj.user.email.split('@')[0];
		} catch (e) { }
		return '';
	}
};

export default LocalStorageHelper;
